import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { Payment } from '@softapps/wws/pos-core';

@Injectable()
export class TerminalRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  authorize(cartId: number, aid: string | number): Promise<boolean> {
    return this.#dataAccess.create(
      {
        path: 'pointofsale-service/point-of-sale/cart/{{cartId}}/payment/terminal/auth-request/finalize',
        pathParams: { cartId },
        queryParams: {
          aid,
        },
      },
      {}
    );
  }

  finalize(cartId: number, terminalPaymentId: number): Promise<Payment> {
    return this.#dataAccess.create(
      {
        path: 'pointofsale-service/point-of-sale/cart/{{cartId}}/payment/terminal/{{terminalPaymentId}}/finalize',
        pathParams: {
          cartId,
          terminalPaymentId,
        },
      },
      {}
    );
  }
}
